import {
  ILearnEmbedTask,
  ILearnTextTask,
  ILearnVideoTask,
  ITranslatableTextTask,
  ILearnDownloadableTask,
  tLearnTaskType
} from 'common/modules/ReactShared';
import { FC } from 'react';

import LearnDownloadableTask from './LearnDownloadableTask';
import LearnEmbedTask from './LearnEmbedTask';
import LearnTextTask from './LearnTextTask';
import LearnTranslatableTextTask from './LearnTranslatableTextTask';
import LearnVideoTask from './LearnVideoTask';
import { ILearnTaskProps } from './types';

export type tLearnComponentType =
  | FC<ILearnTaskProps<ILearnVideoTask>>
  | FC<ILearnTaskProps<ILearnTextTask>>
  | FC<ILearnTaskProps<ILearnEmbedTask>>
  | FC<ILearnTaskProps<ITranslatableTextTask>>
  | FC<ILearnTaskProps<ILearnDownloadableTask>>;

export const learnTaskMap = new Map<tLearnTaskType['type'], tLearnComponentType>([
  ['Tasks::Text', LearnTextTask],
  ['Tasks::TranslatableText', LearnTranslatableTextTask],
  ['Tasks::Video', LearnVideoTask],
  ['Tasks::Embed', LearnEmbedTask],
  ['Tasks::Downloadable', LearnDownloadableTask]
]);
